import React from 'react';
import { useLanguage } from '../context/LanguageContext';

function Footer() {
  const { t, switchLanguage, language } = useLanguage();

  return (
    <footer id="footer-classes">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <div className="footer-logo-circle">
              <img src="/images/logo.webp" alt="JKD Evolution Logo" width="160" height="160" />
            </div>
            <p style={{color: "var(--text-secondary)", marginBottom: "20px"}}>
              {t.footer.description}
            </p>
            <ul className="footer-contact-list">
              <li>
                <span className="footer-contact-icon">💬</span>
                <span><a href="https://wa.me/41764002839" target="_blank" rel="noopener noreferrer">+41 76 400 28 39 (WhatsApp)</a></span>
              </li>
              <li>
                <span className="footer-contact-icon">📞</span>
                <span><a href="tel:+41764002839">+41 76 400 28 39</a></span>
              </li>
              <li>
                <span className="footer-contact-icon">📸</span>
                <span><a href="https://www.instagram.com/mike_j_k_d" target="_blank" rel="noopener noreferrer">@mike_j_k_d</a></span>
              </li>
              <li>
                <span className="footer-contact-icon">📍</span>
                <span><a href="https://maps.app.goo.gl/QpBrETfAYfAkKSK69" target="_blank" rel="noopener noreferrer">Kronenstrasse 12, 8006 Zürich</a></span>
              </li>
            </ul>
          </div>

          <div className="contact-form">
            <h3>{t.footer.classesTitle}</h3>
            <div className="footer-class-card">
              <span className="footer-class-day">{t.footer.days.wednesday}</span>
              <span className="footer-class-time">18:45 – 19:45</span>
            </div>
            <div className="footer-class-card">
              <span className="footer-class-day">{t.footer.days.friday}</span>
              <span className="footer-class-time">18:45 – 19:45</span>
            </div>
            <p className="footer-classes-note">
              {t.footer.privateLessons}
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-language-switcher">
            <button 
              className={language === 'en' ? 'active' : ''} 
              onClick={() => switchLanguage('en')}
              aria-label="English"
            >
              🇬🇧
            </button>
            <button 
              className={language === 'it' ? 'active' : ''} 
              onClick={() => switchLanguage('it')}
              aria-label="Italian"
            >
              🇮🇹
            </button>
            <button 
              className={language === 'de' ? 'active' : ''} 
              onClick={() => switchLanguage('de')}
              aria-label="German"
            >
              🇩🇪
            </button>
        </div>
        <p className="copyright">{t.footer.copyright}</p>
      </div>
    </footer>
  );
}

export default Footer;
